import { IconChevronLeft } from 'components/Icons';
import { IconClarifai } from 'components/Icons/IconClarifai';
import { useRouter } from 'next/router';
import { Tooltip } from 'components/PlatformResourceSelector/Tooltip';
import { ActionList } from 'components/ActionList/ActionList';
import { css, cx } from '@linaria/core';
import { baseTheme } from 'styles/utils';
interface ViewHeaderProps {
  title: string;
  description?: React.ReactNode;
  backUrl?: string;
  isClarifaiManaged?: boolean;
  actions?: React.ReactNode[];
  resourceType?: string;
  contextMenuActions?: React.ReactNode[];
  className?: string;
}
export const ViewHeader: React.FC<ViewHeaderProps> = ({
  title,
  description,
  backUrl,
  isClarifaiManaged = false,
  actions = [],
  contextMenuActions = [],
  resourceType,
  className
}) => {
  const router = useRouter();
  return <div className={cx(viewHeaderStyles.layout, className)}>
      <div className={viewHeaderStyles.content}>
        {resourceType && <div className={cx(viewHeaderStyles.resourceType, backUrl && viewHeaderStyles.backButtonPadding)}>{resourceType}</div>}
        <div className={viewHeaderStyles.titleContainer}>
          {backUrl && <div className={cx(viewHeaderStyles.icon)}>
              <IconChevronLeft size={24} onClick={() => router.push(backUrl)} />
            </div>}
          <h1>{title}</h1>
          {isClarifaiManaged && <Tooltip text="Clarifai's hosted serverless compute offering is always available by default">
              <div style={{
            display: 'grid',
            placeItems: 'center'
          }}>
                <IconClarifai size={24} />
              </div>
            </Tooltip>}
        </div>
        {description && <h2 className={cx(viewHeaderStyles.description, backUrl && viewHeaderStyles.backButtonPadding)}>{description}</h2>}
      </div>
      <ActionList actions={actions} contextMenuActions={contextMenuActions} className={viewHeaderStyles.actionList} />
    </div>;
};
const viewHeaderStyles = {
  layout: "odules__Compute__View__ViewHeader_tsx-layout-l1nipi9k",
  actionList: "odules__Compute__View__ViewHeader_tsx-actionList-as7020a",
  content: "odules__Compute__View__ViewHeader_tsx-content-cllfl95",
  backButtonPadding: "odules__Compute__View__ViewHeader_tsx-backButtonPadding-b1pu3e1y",
  titleContainer: "odules__Compute__View__ViewHeader_tsx-titleContainer-tsvqffw",
  resourceType: "odules__Compute__View__ViewHeader_tsx-resourceType-r1lca38z",
  description: "odules__Compute__View__ViewHeader_tsx-description-d1cu125q",
  icon: "odules__Compute__View__ViewHeader_tsx-icon-i1g2m5m8"
};

require("./ViewHeader.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ViewHeader.tsx");